import { createApp } from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Notifications from '@kyvg/vue3-notification';
import VueScrollTo from 'vue-scrollto';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import store from './store';
import App from './App.vue';
import router from './router';

library.add(fas);
library.add(fab);
library.add(far);
dom.watch();

require('@/assets/styles/main.scss');

createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(router)
  .use(VueScrollTo, {
    offset: -95,
  })
  .use(VueAxios, axios)
  .use(Notifications)
  .use(store)
  .mount('#app');
